import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-203cf497")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"16px"} }, "Collecties", -1)
const _hoisted_3 = {
  key: 0,
  class: "collections"
}
const _hoisted_4 = { class: "collection__name" }
const _hoisted_5 = { class: "collection__details" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_layout_default = _resolveComponent("v-layout-default")!

  return (_openBlock(), _createBlock(_component_v_layout_default, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.result)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.collections, (collection) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: "collection",
                  to: { name: 'collection', params: { collectionId: collection.id } }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(collection.title), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(collection.objects.length) + " objecten", 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}